export class NavigableComponentData {

    version: string = '1.0';

    constructor(init?: Partial<NavigableComponentData>) {
        Object.assign(this, init);
    }
}
